import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useFullscreenModalControls } from '../modals/context/modal-context-provider';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function ManageEventMergeItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const modalControls = useFullscreenModalControls();
    const handleSelect = (): void => {
        modalControls.open({
            type: 'MANAGE_EVENT_MERGE',
            props: {
                primaryEventParameters: {
                    id: clickParams.eventId,
                },
            },
        });
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-manage-event-merge"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
